import { Card, CardContent, CardProps, Grid, styled } from '@mui/material';
import CareTileContent from './CareTileContent';

/** Same tile style as the other Care tiles. */
const StyleCard = styled(Card)<CardProps>(() => ({
  boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.12)',
  border: '1px solid #EFF4FF',
  borderRadius: 12,
  background: '#FFF',
  margin: '12px 16px',
  position: 'relative',
  zIndex: 99,
  padding: 20,
  '& .MuiTypography-root': {
    position: 'relative',
  },
  '& .MuiCardContent-root:last-child': {
    padding: 0,
  },
  /**
   * MM-1132 feedback: tile titles are 17px (was 20px).
   */
  '.MuiTypography-h2': {
    fontSize: 17,
  },
}));

/**
 * One Care tile that opens an external form.
 * title       - tile heading
 * description - text under the heading
 * buttonLabel - action button text
 * href        - form link, opened in a new tab; the button is disabled while it is empty
 */
interface CareLinkTileProps {
  title: string;
  description: string;
  buttonLabel: string;
  href: string;
}

/**
 * MM-1132: Care tile that opens a form in a new tab (button disabled while no link is set).
 * Uses the shared Care tile layout.
 */
const CareLinkTile = ({ title, description, buttonLabel, href }: CareLinkTileProps) => (
  <Grid item xs={12}>
    <StyleCard>
      <CardContent>
        <CareTileContent
          title={title}
          description={description}
          buttonLabel={buttonLabel}
          onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
          disabled={!href}
        />
      </CardContent>
    </StyleCard>
  </Grid>
);

export default CareLinkTile;
